export const translations = {
  en: {
    nav: {
      home: "Home",
      subjects: "Subjects",
      herbs: "Herb Encyclopedia",
      courses: "Courses",
      dashboard: "Dashboard",
      login: "Login",
      logout: "Logout",
      admin: "Admin",
      search: "Search...",
      prakriti: "Prakriti Quiz",
      about: "About",
      myCourses: "My Courses",
      logo: "AyurVidya",
    },
    footer: {
      tagline: "Ancient Wisdom. Modern Learning.",
      desc: "The complete digital encyclopedia of Ayurveda for BAMS students and practitioners.",
      learn: "Learn",
      platform: "Platform",
      copyright: "Built for BAMS students worldwide.",
    },
    home: {
      tagline: "Ancient Wisdom. Modern Learning.",
      subtitle: "The complete digital encyclopedia of Ayurveda for BAMS students, practitioners, and enthusiasts.",
      startLearning: "Start Learning",
      exploreHerbs: "Explore Herbs",
      subjects: "Subjects",
      topics: "Topics",
      herbs: "Herbs",
      students: "Students",
      featuredSubjects: "Featured Subjects",
      whyAyurVidya: "Why AyurVidya?",
      feature1Title: "W3Schools-Style Learning",
      feature1Desc: "Clean, structured topic pages with examples, tables, and clinical notes.",
      feature2Title: "Bilingual Content",
      feature2Desc: "All content available in English and Marathi for regional learners.",
      feature3Title: "Interactive Quizzes",
      feature3Desc: "Test your knowledge with MCQs and flashcards after every topic.",
      feature4Title: "Herb Encyclopedia",
      feature4Desc: "25+ herbs with complete Rasa-Guna-Virya-Vipaka data and modern research.",
      startJourney: "Start Your Journey",
      startJourneyDesc: "Join thousands of BAMS students mastering Ayurveda with structured, comprehensive content.",
      browseSubjects: "Browse All Subjects",
    },
    subjects: {
      title: "All Subjects",
      subtitle: "10 comprehensive subjects covering the complete BAMS curriculum",
      allYears: "All Years",
      year: "Year",
      topics: "topics",
      explore: "Explore",
    },
    topic: {
      introduction: "Introduction",
      historicalContext: "Historical Context",
      coreConcept: "Core Concept",
      clinicalApplications: "Clinical Applications",
      modernComparison: "Modern Medicine Correlation",
      summary: "Summary",
      quiz: "Quiz",
      flashcards: "Flashcards",
      furtherReading: "Further Reading",
      markComplete: "Mark as Complete",
      completed: "Completed ✓",
      bookmark: "Bookmark",
      bookmarked: "Bookmarked",
      addNote: "Add Note",
      saveNote: "Save Note",
      print: "Print",
      prevTopic: "← Previous",
      nextTopic: "Next →",
      minRead: "min read",
      difficulty: "Difficulty",
      beginner: "1st Year",
      intermediate: "2nd Year",
      advanced: "3rd Year",
      onThisPage: "On this page",
      prevLabel: "Previous",
      nextLabel: "Next",
      question: "Question",
      answer: "Answer",
      flipHint: "Click card to flip",
    },
    herbs: {
      title: "Herb Encyclopedia",
      subtitle: "25+ medicinal herbs with complete Ayurvedic and modern research data",
      search: "Search herbs...",
      allCategories: "All Categories",
      botanicalName: "Botanical Name",
      sanskritName: "Sanskrit Name",
      rasa: "Rasa (Taste)",
      guna: "Guna (Properties)",
      virya: "Virya (Potency)",
      vipaka: "Vipaka",
      doshaEffect: "Dosha Effect",
      partsUsed: "Parts Used",
      medicinalUses: "Medicinal Uses",
      preparations: "Preparations",
      dosage: "Dosage",
      contraindications: "Contraindications",
      modernResearch: "Modern Research",
      viewDetails: "View Details",
      about: "About",
      ayurvedicProperties: "Ayurvedic Properties",
      quickReference: "Quick Reference",
      relatedHerbs: "Related Herbs",
      caution: "Caution",
    },
    dashboard: {
      greeting: "Namaste",
      streak: "Day streak",
      overallProgress: "Overall Progress",
      recentActivity: "Recent Activity",
      quizPerformance: "Quiz Performance",
      bookmarks: "Bookmarks",
      enrolledCourses: "Enrolled Courses",
      avgScore: "Avg Score",
      studyStreak: "Study Streak",
      noActivity: "No recent activity. Start learning!",
      noBookmarks: "No bookmarks yet.",
      avgQuizScore: "Avg Quiz Score",
    },
    courses: {
      title: "Courses",
      subtitle: "Structured learning paths for every level",
      free: "Free",
      enroll: "Enroll Now",
      enrolled: "Enrolled",
      continueLearning: "Continue Learning",
      level: "Level",
      duration: "Duration",
      lessons: "lessons",
      students: "students",
      rating: "Rating",
      myCourses: "My Courses",
      noEnrollments: "You haven't enrolled in any courses yet.",
      browseCourses: "Browse Courses",
    },
    auth: {
      login: "Login",
      register: "Register",
      email: "Email",
      password: "Password",
      name: "Full Name",
      loginBtn: "Login",
      registerBtn: "Create Account",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      forgotPassword: "Forgot password?",
    },
    prakriti: {
      title: "Prakriti Quiz",
      subtitle: "Discover your Ayurvedic body constitution",
      question: "Question",
      of: "of",
      notAtAll: "Not at all",
      veryMuch: "Very much",
      next: "Next",
      previous: "Previous",
      submit: "See My Prakriti",
      result: "Your Prakriti",
      dominant: "Dominant Dosha",
      recommendations: "Recommendations",
      retake: "Retake Quiz",
    },
    common: {
      loading: "Loading...",
      error: "Something went wrong.",
      retry: "Retry",
      back: "Back",
      close: "Close",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      search: "Search",
      noResults: "No results found.",
      learnMore: "Learn More",
      viewAll: "View All",
      home: "Home",
      decreases: "Decreases",
      increases: "Increases",
      neutral: "Neutral",
    },
  },
  mr: {
    nav: {
      home: "मुख्यपृष्ठ",
      subjects: "विषय",
      herbs: "औषधी वनस्पती",
      courses: "अभ्यासक्रम",
      dashboard: "डॅशबोर्ड",
      login: "लॉगिन",
      logout: "लॉगआउट",
      admin: "प्रशासक",
      search: "शोधा...",
      prakriti: "प्रकृती चाचणी",
      about: "आमच्याबद्दल",
      myCourses: "माझे अभ्यासक्रम",
      logo: "AyurVidya",
    },
    footer: {
      tagline: "प्राचीन ज्ञान. आधुनिक शिक्षण.",
      desc: "BAMS विद्यार्थी आणि वैद्यांसाठी आयुर्वेदाचा संपूर्ण डिजिटल विश्वकोश.",
      learn: "शिका",
      platform: "प्लॅटफॉर्म",
      copyright: "जगभरातील BAMS विद्यार्थ्यांसाठी विकसित.",
    },
    home: {
      tagline: "प्राचीन ज्ञान. आधुनिक शिक्षण.",
      subtitle: "BAMS विद्यार्थी, वैद्य आणि आयुर्वेद प्रेमींसाठी संपूर्ण डिजिटल विश्वकोश.",
      startLearning: "शिकणे सुरू करा",
      exploreHerbs: "वनस्पती पहा",
      subjects: "विषय",
      topics: "विषय",
      herbs: "वनस्पती",
      students: "विद्यार्थी",
      featuredSubjects: "प्रमुख विषय",
      whyAyurVidya: "AyurVidya का?",
      feature1Title: "संरचित शिक्षण",
      feature1Desc: "उदाहरणे, तक्ते आणि नैदानिक नोट्ससह स्वच्छ विषय पृष्ठे.",
      feature2Title: "द्विभाषिक सामग्री",
      feature2Desc: "इंग्रजी आणि मराठीत सर्व सामग्री उपलब्ध.",
      feature3Title: "परस्परसंवादी प्रश्नमंजुषा",
      feature3Desc: "प्रत्येक विषयानंतर MCQ आणि फ्लॅशकार्डसह ज्ञान तपासा.",
      feature4Title: "औषधी वनस्पती विश्वकोश",
      feature4Desc: "25+ वनस्पती रस-गुण-वीर्य-विपाक डेटासह.",
      startJourney: "आपला प्रवास सुरू करा",
      startJourneyDesc: "हजारो BAMS विद्यार्थ्यांसोबत आयुर्वेद शिका.",
      browseSubjects: "सर्व विषय पहा",
    },
    subjects: {
      title: "सर्व विषय",
      subtitle: "संपूर्ण BAMS अभ्यासक्रम समाविष्ट करणारे 10 विषय",
      allYears: "सर्व वर्षे",
      year: "वर्ष",
      topics: "विषय",
      explore: "पहा",
    },
    topic: {
      introduction: "परिचय",
      historicalContext: "ऐतिहासिक संदर्भ",
      coreConcept: "मुख्य संकल्पना",
      clinicalApplications: "नैदानिक उपयोग",
      modernComparison: "आधुनिक वैद्यकशास्त्र तुलना",
      summary: "सारांश",
      quiz: "प्रश्नमंजुषा",
      flashcards: "फ्लॅशकार्ड",
      furtherReading: "अधिक वाचन",
      markComplete: "पूर्ण म्हणून चिन्हांकित करा",
      completed: "पूर्ण ✓",
      bookmark: "बुकमार्क",
      bookmarked: "बुकमार्क केले",
      addNote: "नोट जोडा",
      saveNote: "नोट जतन करा",
      print: "मुद्रण",
      prevTopic: "← मागील",
      nextTopic: "पुढील →",
      minRead: "मिनिट वाचन",
      difficulty: "कठिणता",
      beginner: "प्रथम वर्ष",
      intermediate: "द्वितीय वर्ष",
      advanced: "तृतीय वर्ष",
      onThisPage: "या पानावर",
      prevLabel: "मागील",
      nextLabel: "पुढील",
      question: "प्रश्न",
      answer: "उत्तर",
      flipHint: "पाहण्यासाठी क्लिक करा",
    },
    herbs: {
      title: "औषधी वनस्पती विश्वकोश",
      subtitle: "25+ औषधी वनस्पती संपूर्ण आयुर्वेदिक डेटासह",
      search: "वनस्पती शोधा...",
      allCategories: "सर्व श्रेणी",
      botanicalName: "वनस्पतिशास्त्रीय नाव",
      sanskritName: "संस्कृत नाव",
      rasa: "रस",
      guna: "गुण",
      virya: "वीर्य",
      vipaka: "विपाक",
      doshaEffect: "दोष प्रभाव",
      partsUsed: "वापरलेले भाग",
      medicinalUses: "औषधी उपयोग",
      preparations: "तयारी",
      dosage: "मात्रा",
      contraindications: "विरोधाभास",
      modernResearch: "आधुनिक संशोधन",
      viewDetails: "तपशील पहा",
      about: "बद्दल",
      ayurvedicProperties: "आयुर्वेदिक गुणधर्म",
      quickReference: "त्वरीत संदर्भ",
      relatedHerbs: "संबंधित वनस्पती",
      caution: "सावधान",
    },
    dashboard: {
      greeting: "नमस्ते",
      streak: "दिवस सलग",
      overallProgress: "एकूण प्रगती",
      recentActivity: "अलीकडील क्रियाकलाप",
      quizPerformance: "प्रश्नमंजुषा कामगिरी",
      bookmarks: "बुकमार्क",
      enrolledCourses: "नोंदणीकृत अभ्यासक्रम",
      avgScore: "सरासरी गुण",
      studyStreak: "अभ्यास सलग",
      noActivity: "अलीकडील क्रियाकलाप नाही. शिकणे सुरू करा!",
      noBookmarks: "अद्याप बुकमार्क नाही.",
      avgQuizScore: "सरासरी प्रश्नमंजुषा गुण",
    },
    courses: {
      title: "अभ्यासक्रम",
      subtitle: "प्रत्येक स्तरासाठी संरचित शिक्षण मार्ग",
      free: "मोफत",
      enroll: "नोंदणी करा",
      enrolled: "नोंदणी केली",
      continueLearning: "शिकणे सुरू ठेवा",
      level: "स्तर",
      duration: "कालावधी",
      lessons: "धडे",
      students: "विद्यार्थी",
      rating: "रेटिंग",
      myCourses: "माझे अभ्यासक्रम",
      noEnrollments: "तुम्ही अद्याप कोणत्याही अभ्यासक्रमात नोंदणी केलेली नाही.",
      browseCourses: "अभ्यासक्रम पहा",
    },
    auth: {
      login: "लॉगिन",
      register: "नोंदणी",
      email: "ईमेल",
      password: "पासवर्ड",
      name: "पूर्ण नाव",
      loginBtn: "लॉगिन",
      registerBtn: "खाते तयार करा",
      noAccount: "खाते नाही?",
      hasAccount: "आधीच खाते आहे?",
      forgotPassword: "पासवर्ड विसरलात?",
    },
    prakriti: {
      title: "प्रकृती चाचणी",
      subtitle: "आपली आयुर्वेदिक शरीर रचना शोधा",
      question: "प्रश्न",
      of: "पैकी",
      notAtAll: "अजिबात नाही",
      veryMuch: "खूप जास्त",
      next: "पुढे",
      previous: "मागे",
      submit: "माझी प्रकृती पहा",
      result: "आपली प्रकृती",
      dominant: "प्रमुख दोष",
      recommendations: "शिफारसी",
      retake: "पुन्हा चाचणी घ्या",
    },
    common: {
      loading: "लोड होत आहे...",
      error: "काहीतरी चुकले.",
      retry: "पुन्हा प्रयत्न करा",
      back: "मागे",
      close: "बंद करा",
      save: "जतन करा",
      cancel: "रद्द करा",
      delete: "हटवा",
      edit: "संपादित करा",
      search: "शोधा",
      noResults: "कोणतेही परिणाम आढळले नाहीत.",
      learnMore: "अधिक जाणून घ्या",
      viewAll: "सर्व पहा",
      home: "मुख्यपृष्ठ",
      decreases: "कमी करते",
      increases: "वाढवते",
      neutral: "तटस्थ",
    },
  },
};
